import { useIsArchivedHousehold, useIsViewer } from '@/hooks/useCurrentHousehold'
import { useEntitlement } from '@/hooks/useEntitlement'

/** True when the active household can't be edited by the caller: a VIEWER role, an archived
 *  household, or a lapsed trial with no subscription (server-enforced by
 *  BillingEntitlementFilter, which still allows reads). False while any of these are loading, so
 *  a paying household never briefly flashes read-only. */
export function useIsReadOnly(): boolean {
  const isViewer = useIsViewer()
  const isArchivedHousehold = useIsArchivedHousehold()
  const { data: entitlement } = useEntitlement()
  const billingLapsed = entitlement !== undefined && !entitlement.entitled
  return isViewer || isArchivedHousehold || billingLapsed
}
